export const priorizationType = 'SELECT/PRIORIZATION';
export const datesType = 'SELECT/DATES';

export const vehTypeSpecials = ['E', 'H', 'X', 'S'];
